var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headerType,{tag:"component"},[(_vm.isAbsolute)?_c('a',{attrs:{"href":_vm.permalink,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.title)}}):_c('nuxt-link',{attrs:{"to":_vm.permalink},domProps:{"innerHTML":_vm._s(_vm.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }